/*
 * @Author: your name
 * @Date: 2021-07-07 10:41:22
 * @LastEditTime: 2022-02-16 10:37:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/frameworks/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import theme from './modules/theme'
// import errorLog from './modules/errorLog'
// import permission from './modules/permission'
// import tagsView from './modules/tagsView'

// import dictCache from './modules/dictCache'
// import orgStructure from './modules/orgStructure'
import createPersistedState from 'vuex-persistedstate'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    theme
    // errorLog,
    // permission,
    // tagsView,
    // user,
    // dictCache,
    // orgStructure
  },
  getters,
  plugins: [createPersistedState()]
})

export default store
